import { ApisauceInstance, create } from 'apisauce';

import { apiMethods, Config } from '@nw/shared/config';

import { getCollegePredictorAccessToken } from '../../../utils/NwCollegePredictorStorageUtils';

import {
  ClientLoginWithCodeRequestType,
  ClientLoginWithCodeResponseType,
  RefreshAuthTokensRequestType,
  RefreshAuthTokensResponseType
} from './types';

import { NwAuthAPIServiceTypes } from '.';

class NwAuthAPIService implements NwAuthAPIServiceTypes {
  api: ApisauceInstance;
  networkCallWithAPISauce: any;

  constructor(networkCallWithAPISauce: any) {
    this.api = create({
      baseURL: `${Config['NW_PREDICTOR_AUTH_URL']}`
    });
    this.networkCallWithAPISauce = networkCallWithAPISauce;
  }

  onLogin(
    requestObject: ClientLoginWithCodeRequestType
  ): Promise<ClientLoginWithCodeResponseType> {
    return this.networkCallWithAPISauce(
      this.api,
      'login/v1/',
      requestObject,
      apiMethods.post
    );
  }

  getRefreshToken = (
    requestObject: RefreshAuthTokensRequestType
  ): Promise<RefreshAuthTokensResponseType> => {
    return this.networkCallWithAPISauce(
      this.api,
      `refresh_auth_tokens/v1/`,
      requestObject,
      apiMethods.post,
      {
        getAccessToken: () => getCollegePredictorAccessToken()
      }
    );
  };
}

export { NwAuthAPIService };
